import { ArrowRight } from "lucide-react";
import { useReveal } from "../../lib/reveal";

export default function Hero() {
  const { ref, visible } = useReveal();
  return (
    <section
      id="top"
      ref={ref}
      data-testid="hero-section"
      className="relative pt-32 md:pt-40 pb-20 md:pb-28 overflow-hidden"
      style={{ backgroundColor: "#EAE7E0" }}
    >
      <div className="grain absolute inset-0" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className={`lg:col-span-6 reveal ${visible ? "in" : ""}`}>
          <p className="overline mb-8">O ponto mais alto do seu curso</p>
          <h1 className="font-serif font-light leading-[0.95] tracking-tight text-[#1C1C1C] text-5xl sm:text-6xl lg:text-7xl">
            Transforme seu curso em uma{" "}
            <em className="italic text-[#556052]">experiência</em> inesquecível.
          </h1>
          <p className="mt-8 text-base md:text-lg font-light leading-relaxed text-[#556052] max-w-xl">
            Há 20 anos a MetierCom cria kits sob medida para produtores de cursos e
            mentorias. Não vendemos brindes — entregamos pertencimento,
            posicionamento premium e a memória que faz o aluno voltar.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a href="https://mautic.remindbrindes.com.br/metiercomlporc1" target="_blank" rel="noreferrer" data-testid="hero-primary-cta" className="btn-primary">
              Solicitar Orçamento <ArrowRight size={16} />
            </a>
            <a href="#cases" data-testid="hero-secondary-cta" className="btn-outline">
              Ver Cases
            </a>
          </div>

          <div className="mt-14 flex items-center gap-8">
            <div>
              <p className="font-serif text-4xl text-[#1C1C1C] leading-none">20</p>
              <p className="overline mt-2 text-[#556052]">Anos</p>
            </div>
            <div className="w-px h-12 bg-[rgba(28,28,28,0.12)]" />
            <div>
              <p className="font-serif text-4xl text-[#1C1C1C] leading-none">+950</p>
              <p className="overline mt-2 text-[#556052]">Eventos atendidos</p>
            </div>
            <div className="w-px h-12 bg-[rgba(28,28,28,0.12)] hidden sm:block" />
            <div className="hidden sm:block">
              <p className="font-serif text-4xl text-[#1C1C1C] leading-none">BR</p>
              <p className="overline mt-2 text-[#556052]">Cobertura nacional</p>
            </div>
          </div>
        </div>

        <div className={`lg:col-span-6 reveal ${visible ? "in" : ""}`} style={{ transitionDelay: "200ms" }}>
          <div className="relative">
            <img
              src="https://static.prod-images.emergentagent.com/jobs/6a000596-9294-4f6e-b050-33055cbb9274/images/ee70578e07f315db3249524a2a4fb939d879c63b390034f0f76a974e06d97fc8.png"
              alt="Aluno abrindo kit MetierCom"
              data-testid="hero-image"
              className="w-full h-[520px] md:h-[640px] object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-[#0B2E24] text-[#FAFAFA] p-6 md:p-8 max-w-[260px] hidden md:block">
              <p className="overline text-[#C5A059]">Curadoria</p>
              <p className="font-serif text-xl mt-3 leading-snug">
                Cada item escolhido para conversar com o tema do seu evento.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
